import React from 'react';
import { formatDuration } from '../../lib/beachvision-utils';

const diffColors = {
  beginner: 'text-emerald-300',
  intermediate: 'text-amber-300',
  advanced: 'text-red-300',
};

/**
 * Drill row: thumb, duration, title, source with coral mark, difficulty.
 */
export function DrillCard({ drill }) {
  const open = () => {
    if (drill.url) {
      window.open(drill.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <button
      type="button"
      onClick={open}
      disabled={!drill.url}
      className="w-full text-left rounded-2xl bg-beachvision-surface-low overflow-hidden flex hover:brightness-110 transition-[filter] disabled:opacity-60 min-h-[96px]"
    >
      <div className="relative w-28 shrink-0 bg-gradient-to-br from-beachvision-coral/35 to-beachvision-teal/20">
        <span className="absolute bottom-2 right-2 rounded bg-black/75 px-1.5 py-0.5 text-xs text-white font-mono">
          {formatDuration(drill.duration_seconds)}
        </span>
      </div>
      <div className="p-4 flex-1 min-w-0 flex flex-col justify-center">
        <h4 className="font-display font-bold text-white text-sm leading-snug line-clamp-2">
          {drill.title}
        </h4>
        <div className="flex items-center justify-between gap-2 mt-2">
          <div className="flex items-center gap-2 min-w-0">
            <span className="h-7 w-7 rounded-full bg-beachvision-coral flex items-center justify-center text-beachvision-on-coral font-display font-black text-xs shrink-0">
              {(drill.source && drill.source.charAt(0).toUpperCase()) || 'A'}
            </span>
            <p className="text-xs text-beachvision-muted truncate">{drill.source}</p>
          </div>
          <span
            className={`text-xs font-display font-bold capitalize shrink-0 ${
              diffColors[drill.difficulty] || diffColors.intermediate
            }`}
          >
            {drill.difficulty}
          </span>
        </div>
      </div>
    </button>
  );
}
